import { render, staticRenderFns } from "./MailBlocTextForm.vue?vue&type=template&id=3af00915"
import script from "./MailBlocTextForm.vue?vue&type=script&lang=ts"
export * from "./MailBlocTextForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports